import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/site/Reveal";

const faqs = [
  { q: "What exactly is ASYA?", a: "A closed-loop smart skincare system with three parts: VIBE, a handheld micro-jet applicator; DOSE, single-use serum cartridges; and GAZE, an AI app that scans your skin and personalizes every treatment." },
  { q: "How does the AI personalization work?", a: "GAZE uses your phone camera to assess your skin and a proprietary classifier localizes 11 distinct conditions. That analysis directly sets the formulation and dose VIBE delivers — the AI physically changes what is applied, not just what is displayed." },
  { q: "Is it safe for sensitive skin?", a: "Yes. Cartridges are sealed and single-dose to prevent cross-contamination, formulations are dispensed in fixed volumes to avoid over-application, and our clinical studies were conducted under formal ethics approval." },
  { q: "How much does it cost?", a: "The device is $279 one-time. DOSE serum cartridges are delivered by subscription from $29/mo, which you can pause or cancel anytime." },
  { q: "When does it ship?", a: "ASYA debuts at CES 2027. Joining the waitlist secures early access and priority shipping when we launch — no payment is taken today." },
  { q: "Do I need any training to use it?", a: "No. Insert a cartridge, press once, and VIBE does the rest. It is designed for daily at-home use with the simplicity of an everyday device." },
];

export const Faq = () => (
  <section id="faq" className="relative py-28 md:py-40 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10">
      <div className="grid md:grid-cols-12 gap-10">
        <Reveal className="md:col-span-4">
          <p className="overline mb-5">Questions</p>
          <h2 className="font-serif font-light text-5xl md:text-6xl leading-[0.95] tracking-[-0.02em]">
            Everything you want to know.
          </h2>
        </Reveal>

        <div className="md:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-white/10">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-serif text-xl md:text-2xl py-6 hover:no-underline hover:text-primary transition-colors"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6 max-w-2xl">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
